import { useFormContext } from 'react-hook-form';

import type { InvoiceFilterSchema } from './filter-schema';

export const useInvoiceFilterFormContext = () => {
  const context = useFormContext<InvoiceFilterSchema>();
  return context;
};
